import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    ...theme(props).typography.smallFont.css(),
    color: theme(props).typography.primary.color,
}));
